<template>
  <collapsible-section class='_pt0 _pb0' :collapsed='collapseLanguageAssistance'>
    <template #headerText>
      <p class='color-leaf'>Language Assistance</p>
    </template>
    <template #collapsibleSection class='advanced-table-section-header'>
      <async-loader v-if='loading'/>
      <div v-else container>
        <div row>
          <div class="_mbs">
            <div grid>
              <div column="3">
                <app-labeled-data
                  :data='getDisplayValueFromOptionsSet("spokenWrittenlanguageOptions", language.writtenLanguage)'
                  label='Written Language:'
                />
              </div>
              <div column="3">
                <app-labeled-data
                  :data='getDisplayValueFromOptionsSet("spokenWrittenlanguageOptions", language.spokenLanguage)'
                  label='Spoken Language:'
                />
              </div>
              <div column="3">
                <app-labeled-data
                  :data='getDisplayValueFromOptionsSet("raceOptions", language.raceCode)'
                  label='Race:'
                />
              </div>
              <div column="3">
                <app-labeled-data
                  :data='getDisplayValueFromOptionsSet("ethnicityOptions", language.ethnicityCode)'
                  label='Ethnicity:'
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </collapsible-section>
</template>

<script>
  import AsyncLoader from '@molecules/AsyncLoader'
  import CollapsibleSection from '@sections/CollapsibleSection'
  import AppLabeledData from '@molecules/LabeledData'
  import SelectOptions from '@mixins/SelectOptions'

  export default {
    mixins: [SelectOptions],
    components: {
      CollapsibleSection,
      AppLabeledData,
      AsyncLoader
    },
    props: {
      language: {
        type: Object,
        default() {
          return {}
        }
      },
      loading: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      collapseLanguageAssistance() {
        return (
          !this.language.writtenLanguage &&
          !this.language.spokenLanguage &&
          !this.language.ethnicityCode &&
          !this.language.raceCode
        )
      }
    }
  }
</script>
